
import { defaultEmployee, IEmployee } from "features/setup/models/Employee";

export interface IAdvanceOnSalary {
  id: number, 

  code: string,
  issueDate: Date,
  status: string,
  statusDate: Date,
  statusPurpose: string,

  employeeId: number,
  personId: number,

  employee: IEmployee,
      
  employeeRegistrationNumber: string,
  employeeStatus: string,

  //personAgent: IPersonAgent,
  personFullName: string,
  personFullNameFR: string,
  personFullNameEN: string,

  advanceType: string,
  description: string,
  advanceDate: Date,

  requestedAmount: number,
  acceptedAmount: number,
  accessories: number,
  amount: number,

  reimbursementStartDate: Date,
  reimbursementBaseAmount: number,
  reimbursementFrequency: string,  

  reimbursementCount: number,
  reimbursementEndDate: Date,
}

export const defaultAdvanceOnSalary : IAdvanceOnSalary = {
  id: 0,

  code: '',
  issueDate: new Date(),
  status: '95',
  statusDate: new Date(),
  statusPurpose: '',
  
  employeeId: 0,
  personId: 0,

  employee: defaultEmployee,
  
  employeeRegistrationNumber: '',
  //personAgentManualCode: '',
  employeeStatus: '',

  //personAgent: defaultPersonAgent,

  personFullName: '',
  personFullNameFR: '',
  personFullNameEN: '',

  advanceType: '',
  description: '',
  advanceDate: new Date(),

  requestedAmount: 0,
  acceptedAmount: 0,
  accessories: 0,
  amount: 0,

  reimbursementBaseAmount: 0,
  reimbursementFrequency: 'M',
  reimbursementStartDate: new Date(),

  reimbursementCount: 0,
  reimbursementEndDate: new Date(),
}

export interface IAdvanceOnSalarySearch {

  advanceType: string,
  name: string,
  description: string,  

  dateFrom: Date,
  dateTo: Date
}
